<template>
    <div class="card_state " v-if="listitem">
        <card_meta :videourl="listitem?.video" :imgurl="listitem?.image" :gamename="listitem?.name"  :id="listitem?.id"/>
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue'
import card_meta from './card_meta.vue'
const objurl = ref<any>([])
const props = defineProps({
    CardData: {
        type: [Object, Array],
    },
    typedata: {
        type: [Array]
    },
    index: {
        type: [String, Number]
    },
    stateindex: {
        type: [String, Number]
    },
    listitem: {
        type: [Object, Array]
    }
})
</script>
<style  lang="less" scoped>
.ssdd {}

.card_state {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    border: 2px solid transparent;
    cursor: pointer;
}
</style>